/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionaryType } from 'app/shared/model/clinical-dictionary-type.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { ILabTestItem } from 'app/shared/model/lab-test-item.model';
import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { IDiagLabPanel } from 'app/shared/model/diag-lab-panel.model';

export interface ILabTestItemAttribute {
  id?: string;
  name?: string;
  value?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  attributeType?: IClinicalDictionaryType | null;
  attribute?: IClinicalDictionary | null;
  testItem?: ILabTestItem | null;
  diagLab?: IDiagLab | null;
  panel?: IDiagLabPanel | null;
}

export const defaultValue: Readonly<ILabTestItemAttribute> = {
  active: false,
};
